import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../Spinner";
import Sheet from "../Sheet";
import Header from "./Header";
import Content from "./Content";
import useApi from "../../../utils/api";

function ProfileSheet({ isOpen, close, id }: any) {
    const { t } = useTranslation();
    const { authGet } = useApi();

    const { data: user, isLoading } = useQuery({
        queryKey: [`/users/${id}`],
        queryFn: ({ queryKey }) => {
            const [url] = queryKey;
            return authGet(url as any);
        },
        enabled: !!id
    });

    return (
        <Sheet open={isOpen} close={close} title={t("profile")}>
            {isLoading ? (
                <div className="tw-flex tw-w-full tw-h-full tw-justify-center tw-py-10">
                    <Spinner className="tw-h-10 tw-w-10 tw-text-primary" />
                </div>
            ) : (
                <div className="tw-flex tw-flex-col tw-w-full tw-h-full">
                    <Header user={user} />
                    <Content user={user} />
                </div>
            )}
        </Sheet>
    );
}

export default ProfileSheet;
